import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "4.7",
      stroke: "currentColor",
      "stroke-width": "1.75"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.75",
      d: "m14.55 14.55 3.8 3.8M4.25 8H6.5m-3 3h3m-2.25 3H6.5"
    }, null, -1)
  ]))]))
}
export default { render: render }